import { userSetupStatusStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupStatus";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

userSetupStatusStyles.title = {
    variant: "h5",
    css: css`
        padding-bottom: 15px;
        font-weight: 700;
        color: ${COLORS.text.main};
        font-family: ${TYPOGRAPHY.fontFamily.title};
        font-style: normal;
    `,
};
userSetupStatusStyles.sendActivationEmailButton = {
    variant: "secondary",
    css: css`
        border-radius: 0px;
        border-radius: 0;
        padding: 10px 34px;
        background: ${COLORS.background.main};
        border: 2px solid ${COLORS.primary.base} !important;
        font-family: ${TYPOGRAPHY.fontFamily.title};
        &:hover {
            background: ${COLORS.background.main};
            border: 2px solid ${COLORS.text.accent} !important;

            span[class^="TypographyStyle"] {
                color: ${COLORS.text.accent};
            }
        }

        span[class^="TypographyStyle"] {
            color: ${COLORS.text.main};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            font-family: ${TYPOGRAPHY.fontFamily.title};
        }
    `,
};
userSetupStatusStyles.activationStatus = {
    css: css`
        label {
            color: ${COLORS.text.main};
            font-family: ${TYPOGRAPHY.fontFamily.title};
        }
    `,
};
userSetupStatusStyles.lastSignInLabel = {
    css: css`
        color: ${COLORS.text.main};
        font-family: ${TYPOGRAPHY.fontFamily.title};
    `,
};
userSetupStatusStyles.accountStatusLabel = {
    css: css`
        color: ${COLORS.text.main};
        font-family: ${TYPOGRAPHY.fontFamily.title};
        font-style: normal;
    `,
};